import { render } from "./Cases.vue?vue&type=template&id=1554960e&scoped=true&ts=true"
import script from "./Cases.vue?vue&type=script&lang=ts"
export * from "./Cases.vue?vue&type=script&lang=ts"

import "./Cases.vue?vue&type=style&index=0&id=1554960e&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1554960e"]])

export default __exports__